import { Currency } from 'src/common/types/common/Currency';

export const priceFormatter = (
  amount: number,
  currencyCode: string,
  precision = 0,
): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    currency: currencyCode,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
  return formatter.format(amount);
};

export const completePriceFormatter = (
  amount: number | undefined,
  currencyCode: string,
  currencySymbol: string,
  precision = 0,
): string => {
  if (!amount) return '';
  const formattedAmount = priceFormatter(amount, currencyCode, precision);
  return `${currencySymbol}${formattedAmount}`;
};

export const formatCurrencyLabel = ({ code, symbol }: Currency): string => {
  const currencyCode = symbol === '$' ? code.slice(0, 2) : code;
  const currencySymbol = symbol !== code ? symbol : '';
  // 0xa0 is the non-breakable space character
  return `${currencyCode}\xa0${currencySymbol}`.trim();
};
